import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {BaseError} from "../../components/pages/base-error";
import { ExternalServer } from "../../models/external-server";

@Injectable()
export class ExternalServerControllerService extends BaseError {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient,
              public toastr: ToastrService) {
    super(toastr);
  }

  public getExternalServers(): Observable<ExternalServer[]> {
    return this.http.get(this.baseUrl + "/externalserver") as Observable<ExternalServer[]>;
  }

  public publishInstanceSettings(serverId: string) {
    return this.http.post(this.baseUrl + "/externalserver/" + serverId + "/publishSettings", {});
  }
}
